"use client"

import {useQRCode} from "next-qrcode";
import {useTranslations} from "next-intl";
import {useSyncExternalStore} from "react";
import {buildApkDownloadUrl} from "@/lib/utils/apkDownload";

// The link carries the partner mark from localStorage, so it only exists in the
// browser: the server snapshot is empty and the code is drawn after hydration.
const subscribe = () => () => {
};
const getServerUrl = () => '';

// Desktop footer QR: the same link as the "Download APK" button next to it —
// apk-service with the visitor's partner mark (`click` + `traffic`), so a scan
// downloads the app straight away and keeps attribution. The one-time login
// code the button adds for a signed-in player is left out on purpose: a code
// drawn on the screen would sign in whoever scans it.
export const AppQrCode = () => {
    const {Canvas} = useQRCode();
    const t = useTranslations();
    const url = useSyncExternalStore(
        subscribe,
        () => buildApkDownloadUrl() ?? '',
        getServerUrl,
    );

    return (
        <div className={'flex flex-col items-center gap-[6px]'}>
            <div role={'img'} aria-label={t('AppFooter.qrLabel')}
                 className={'size-[76px] rounded-[6px] bg-white p-[4px]'}>
                {url ? (
                    <Canvas
                        text={url}
                        options={{
                            errorCorrectionLevel: 'M',
                            margin: 0,
                            width: 68,
                            color: {dark: '#000', light: '#fff'},
                        }}
                    />
                ) : null}
            </div>
            <span className={'text-[10px] leading-[14px] text-[#BFBDB5]'}>{t('AppFooter.openOnPhone')}</span>
        </div>
    );
};
